<template>
  <modal @close="closeRegModal" :isRegistrationDesktop="true" :isRegistration="true" :click_outside="false">
    <p class="text-white font-bold xl:text-xl lg:text-xl top-font xl:-mt-10 lg:-mt-10 text-base" slot="header">
      Регистрация на игру</p>
    <div class="ml-6 mb-3 xl:-mt-10 lg:-mt-10 text-mxs text-additional-text font-semibold relative">
      <span class="text-sm  text-brand-light">Шаг {{ step_number }}</span> из 2
      <img v-if="step_number>1" class="absolute w-3 h-3 pin-l pin-t -ml-4 rotated cursor-pointer"
           src="@/assets/SVG/arrow_down.svg" @click="step_number--" alt="">
    </div>

    <div v-if="step_number===1">
      <div class="text-sm font-semibold text-main-text">
        <p class="ml-6 mb-3">Корпоративная лига</p>
        <div class="mx-6 mb-6 font-normal">
          <div class="mb-2">
            <img class="h-4 w-4 mr-2" src="@/assets/SVG/calendar-light.svg" alt=""> <span
              class="align-text-top">{{ getEventDate }}</span>
          </div>
          <div>
            <img class="h-4 w-4 mr-2" src="@/assets/SVG/place.svg" alt=""> <span
              class="align-text-top">{{ event.place }}</span>
          </div>
        </div>
        <p class="text-mxs text-additional-text ml-6 mx-5 -mb-2 cursor-default" v-if="form.team_id">Название команды</p>
        <div class="flex selector mt-2 mx-6 justify-start border-transparent">
          <select-box :placeholder="newTeam ? 'Создать команду' : 'Выберите команду'"
                      class="font-bold text-additional-text selBox w-full"
                      :listItems="teams"
                      @input="setValue($event)"
                      :value="teamName"
                      @newTeamCreate="newTeam = true; teamName = ''"
                      @hideTeamCreate="newTeam = false;/* teamForm.name = ''*/"
                      :withTeamCreate="true"
                      :teamCreatingIsDisabled="!allowCreate || selected_team"
                      :selected_team="selected_team"
          >
          </select-box>

        </div>
        <span v-if="form.errors.has(`team_id`)" class="text-red text-xs font-normal ml-6"
              v-text="form.errors.first(`team_id`)"></span>

        <div class="mx-5 relative text-additional-text">
          <div class="my-4">
            <moz-input v-if="newTeam"
                       v-model="teamForm.name"
                       type="text"
                       placeholder="Название команды"
                       class="-mt-1"
                       :error="teamForm.errors.first('name')"
            >
            </moz-input>
            <moz-input v-model="form.captain_name"
                       type="text"
                       placeholder="Имя"
                       class=""
                       :error="form.errors.first('captain_name')"
            >
            </moz-input>
            <moz-input v-model="form.captain_phone"
                       type="tel"
                       inputmode="tel"
                       placeholder="Телефон для связи"
                       class=""
                       :error="form.errors.first('captain_phone')"
            >
            </moz-input>
            <moz-input v-model="form.comment"
                       type="text"
                       ref="name"
                       placeholder="Комментарий"
                       class=""
            >
            </moz-input>
          </div>
        </div>

        <plus-minus-counter class="px-10 lg:px-5" :max="event.max_team_players" v-model="form.player_count"
                            :def="min_player_count" :min="min_player_count"></plus-minus-counter>
        <p v-if="teamValue===null" class="flex w-full justify-center">1</p>


        <user-data-change-q v-if="userdata_change_q"
                            @close="userdata_change_q = false"
                            @agree="allowMod(); userdata_change_q = false"
                            @notAgree="userdata_change_q = false"></user-data-change-q>
      </div>

    </div>

    <div v-else>

      <div class="mx-5 relative text-additional-text">
        <div class="my-4">
          <moz-input v-model="form.company_name"
                     type="text"
                     placeholder="Название компании*"
                     class=""
                     :error="form.errors.first('company_name')"
          >
          </moz-input>
          <moz-input v-model="form.company_comment"
                     type="text"
                     ref="company_comment"
                     placeholder="Краткая информация*"
                     class=""
                     :error="form.errors.first('company_comment')"
          >
          </moz-input>
        </div>
      </div>


      <p class="mx-5 text-mxs text-brand-light"><span class="font-semibold">Внимание!</span> Можно добавить <span
          class="font-semibold">
              не более 5 файлов</span> в форматах jpg, png, psd, ai</p>

      <div class="mx-5 mt-5 min-h-22">

        <div v-if="existingLogos.length">
          <div v-for="file in existingLogos" :key="file" class="flex justify-start text-sm mb-2">
            <p class="max-w-4/5 truncate">{{ getExistingFileName(file) }}</p>
            <div class="remove ml-4">
              <div @click.prevent="removeExistingImage(file)" class="remove cursor-pointer">
                <img src="@/assets/SVG/cross-partners.svg" class="h-4 w-4" alt="">
              </div>
            </div>
          </div>
        </div>

        <div v-if="files.length">
          <div v-for="file in files" :key="file.id" class="flex justify-start text-sm mb-2">
            <p class="max-w-4/5 truncate">{{ file.name }}</p>
            <div class="remove ml-4">
              <div @click.prevent="removeImage(file)" class="remove cursor-pointer">
                <img src="@/assets/SVG/cross-partners.svg" class="h-4 w-4">
              </div>
            </div>
            <br/>
          </div>
        </div>
      </div>
      <span v-show="fileFormatError" class="text-red text-10px md:text-xs font-normal ml-5"
            v-text="'Неверный формат. Файл не был загружен'"></span>

      <vue-upload-component
          ref="upload"
          class="upl"
          v-model="files"
          :multiple="true"
          :drop="true"
          :drop-directory="true"
          :thread="5-existingLogos.length"
          :maximum="5-existingLogos.length"
          @input-filter="inputFilter">
        <slot v-if="currentLogosCount<5">
          <div class="flex flex-row items-center mx-5 mt-5 h-8" @click="addLogoClick"
               :class="currentLogosCount<5 ? 'cursor-pointer' : 'cursor-default'">
            <div
                class="outline-none rounded-full flex flex-row justify-center items-center h-8 w-8"
                :class=" currentLogosCount<5 ? 'bg-brand-light hover-up' : 'bg-additional-text' ">
              <font-awesome-icon class="text-white text-xl" :icon="['fal', 'plus']">
              </font-awesome-icon>
            </div>
            <div class="text-xs text-additional-text font-bold ml-4">Добавить логотип компании</div>
          </div>
        </slot>
        <slot v-else>
          <div class="mx-5  h-8">
          </div>
        </slot>
      </vue-upload-component>


      <div class="flex justify-start items-end my-6 ml-5">
        <label class="flex justify-start mt-1 cursor-pointer text-mxs">
                  <span class="mr-3">
                    <input class="checkbox" :checked="form.play_for_first_time" v-model="form.play_for_first_time"
                           @click="$emit('selectTeam')" type="checkbox">
                    <span class="checkbox-custom"></span>
                  </span> <span class="pt-1">Мы играем в первый раз</span>
        </label>
      </div>


    </div>
    <div class="border-b mt-6"></div>
    <p class="ml-5 my-6 text-sm font-semibold text-main-text">К оплате: <span class="text-brand-light"
                                                                              v-text="`${gameCost/100} ${event.currency || 'RUB'}`"></span>
    </p>
    <div class="flex mb-6 relative">
      <button v-if="step_number===1"
              class="rezerv text-main-text flex-grow mx-5 py-3 font-semibold cursor-pointer bg-brand-yellow"
              @click="firstStepVal">
        Продолжить &#10140;
      </button>
      <button v-else class="rezerv flex-grow mx-5 py-3 font-semibold cursor-pointer"
              :class="spinner? 'text-brand-light' : 'text-white'" @click="closeReg" :disabled="spinner">
        Завершить регистрацию
      </button>
      <img v-show="spinner" class="absolute spinner" src="@/assets/spinners/tail-spin.svg" alt="">
    </div>
  </modal>

</template>

<script>
import {
  mapActions,
  mapState,
} from 'vuex';
import ru from 'date-fns/locale/ru';
import format from 'date-fns/format';
import ModalMixin from '@/mixins/modals';
import getCookie from '@/mixins/getCookie';
import Modal from '@/views/modals/base-modal.vue';
import SelectBox from '@/views/partners/selectbox.vue';
import Form from 'form-backend-validation';
import client from '@/clients/player';
import UserDataChangeQ from '../without-online-pay/userdata-change-q.vue';
import PlusMinusCounter from '../../components/plus-minus-counter.vue';
// eslint-disable-next-line import/first
import VueUploadComponent from 'vue-upload-component';

export default {
  name: 'Participate',
  components: {
    Modal,
    SelectBox,
    UserDataChangeQ,
    PlusMinusCounter,
    VueUploadComponent,
  },

  props: ['thanks', 'participate', 'gameCost', 'event', 'user_events', 'reg_type', 'privileged_team', 'city_id', 'allowed_teams',
    'worksWithAllowedTeams'],

  mixins: [ModalMixin, getCookie],

  data() {
    return {
      min_player_count: this.city_id === 6 ? 1 : 2,
      form: new Form({
        event_day_id: this.event.uuid,
        team_id: '',
        captain_phone: '',
        comment: '',
        captain_email: '',
        player_count: this.city_id === 6 ? 1 : 2,
        captain_name: '',
        play_for_first_time: false,
        roistat_first_visit: this.getCookie('roistat_first_visit'),
        roistat_visit: window.roistat && window.roistat.visit ? window.roistat.visit : '',

        utm_source: this.getCookie('mozgoUtmSource'),
        utm_content: this.getCookie('mozgoUtmContent'),
        utm_medium: this.getCookie('mozgoUtmMedium'),
        utm_term: this.getCookie('mozgoUtmTerm'),
        utm_campaign: this.getCookie('mozgoUtmCampaign'),

        company_name: '',
        company_comment: '',
        company_files: [],


      }, { http: client }),
      teamForm: new Form({
        name: '',
      }, { http: client }),
      ext: '',
      show: true,
      teamSetup: '',
      teamName: '',
      teamValue: 2,
      count: '',
      rezerv: false,
      loaded: false,
      name: '',
      teamList: [],
      userdata_change_q: false,
      newTeam: false,
      refName: '',
      newTeamName: '',
      maxTeams: 10,
      selected_team: false,

      files: [],
      existingLogos: [],
      step_number: 1,
      fileFormatError: false,
      fileForDelete: '',
      spinner: false,
      // currentLogos: [],
    };
  },

  watch: {
    teamValue() {
      this.form.player_count = this.teamValue;
    },
    newTeam() {
      if (this.newTeam) this.form.team_id = 0;
    },
    count() {
      if (this.teamValue === 1 || 5 || 6 || 7 || 8 || 9 || 10) {
        this.count = 'человек';
      } else {
        this.count = 'человека';
      }
    },
    teamSetup() {
      return this.teamSetup;
    },
    formWatcher() {
      if (this.formWatcher) {
        if (this.$metrika) {
          this.$metrika.reachGoal('offline-reg-fields-filled');
        }
      }
    },
  },

  created() {
    this.loaded = true;
    Object.keys(this.form)
        .forEach((item) => {
          if (this.userData[item]) {
            this.form[item] = this.userData[item];
          }
        });
    this.form.captain_name = this.userData.name;
    this.form.captain_email = this.userData.email;
    this.form.captain_phone = this.userData.phone;
    if (this.$metrika) {
      this.$metrika.reachGoal('offline-reg-form-opened');
    }
  },

  computed: {
    ...mapState({
      userData: state => state.auth.user,
    }),
    teams() {
      const line_events = this.user_events.filter(item => item.event_record_id === this.event.event_record_id);
      if (line_events.length) {
        this.selected_team = true;
        return this.$store.getters.userTeams({
          key: 'id',
          value: line_events[0].team_id
        });
      }
      if (this.privileged_team) {
        return this.$store.getters.userTeams({
          key: 'id',
          value: this.privileged_team
        });
      }
      if (this.allowed_teams && this.allowed_teams.length > 0) {
        return this.allowed_teams;
      }
      return this.$store.getters.userTeams({
        key: 'city_id',
        value: this.city_id
      });
    },

    teamsCount() {
      return this.$store.getters.userTeamsLength;
    },

    countSumm() {
      return this.form.player_count * this.gameCost / 100;
    },

    getEventDate() {
      const dates = [];
      dates.push(format(this.event.played_at, 'DD MMMM, dd', { locale: ru }));
      return dates[0];
    },
    allowCreate() {
      return !(this.teamsCount >= 10) && !this.privileged_team && !(this.allowed_teams && this.allowed_teams.length > 0);
    },

    currentLogosCount: {
      cache: false,
      get() {
        return this.existingLogos.length + this.files.length;
      },
    },
    formWatcher() {
      if (this.form.captain_email !== '' && this.form.captain_name !== '' && this.form.captain_phone !== '' && this.form.team_id !== '') {
        return true;
      }
    },
  },

  methods: {
    ...mapActions(['addUserApplication', 'addUserTeams', 'updateUserData']),
    cleanNewTeam() {
      this.newTeam = false;
      this.teamForm.name = '';
    },
    declOfNum(number, titles) {
      const cases = [2, 0, 1, 1, 1, 2];
      return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    },
    sendFormData() {
      const temp_user = {
        name: this.form.captain_name,
        phone: this.form.captain_phone,
      };
      const uploaded = this.files.map(item => item.file);
      this.form.company_files = [...uploaded, ...this.existingLogos];
      this.form.play_for_first_time = this.form.play_for_first_time ? 1 : 0; // потому, что это не json, нужно для бэка, иначе не сожрёт
      this.form.post('/applications')
          .then((response) => {
            this.spinner = false;
            const idx = this.$store.state.applications.applications.findIndex(item => item.uuid === response.games_event_day_id);
            if (idx >= 0) {
              response.games_event_record_id = this.$store.state.applications.applications[idx].event_record_id;
            }
            this.addUserApplication(response);
            if (temp_user !== this.userData.name) {
              this.updateUserData(temp_user);
            }
            if (this.$metrika) {
              this.$metrika.reachGoal('offline-reg');
            }
            if (response.status === 'reserve' && this.reg_type === 'registration') {
              this.$emit('in_reserve');
              return;
            }
            if (this.reg_type === 'registration') {
              if (window && window.BigBrother) window.BigBrother.reachGoal('REGISTER');
              if (this.$metrika) {
                this.$metrika.reachGoal('offline-reg-submitted');
              }
              this.$emit('thanks');
              return;
            }

            this.$emit('thanks_res');
          })
          .catch(() => {
            this.spinner = false;
          });
    },
    closeReg() {
      this.spinner = true;
      this.sendFormData();
    },

    firstStepVal() {
      if (this.form.team_id) {
        const currentTeam = this.userData.teams.find(team => team.id === this.form.team_id);
        if (currentTeam.company) { // Вот тут переносим данные о компании и логосы в форму
          this.form.company_name = currentTeam.company.name;
          this.form.company_comment = currentTeam.company.description;
          this.existingLogos = Object.values(currentTeam.company.media);
        }
        this.step_number++;
        return;
      }

      this.newTeamName = this.teamForm.name;
      this.teamForm.post(`/teams?city_id=${this.city_id}`)
          .then((response) => {
            response.city_id = parseInt(response.city_id);
            this.addUserTeams(response);
            this.newTeam = false;
            this.form.team_id = response.id;
            this.step_number++;
          });
    },

    onEditFieldClick(event) {
      if (event.target.tagName !== 'IMG') {
        return;
      }
      this.refName = event.target.getAttribute('refName');
      this.userdata_change_q = true;
    },
    allowMod() {
      const ref = this.refName;
      const target = this.$refs[ref];
      target.removeAttribute('readonly');
    },

    setValue(val) {
      this.teamName = val;
      this.form.team_id = this.teams[val].id;
    },

    removeImage(file) {
      this.$refs.upload.remove(file);
    },
    removeExistingImage(file) {
      const idx = this.existingLogos.findIndex(item => item === file);
      this.existingLogos.splice(idx, 1);
    },

    // eslint-disable-next-line consistent-return
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        // Will not be added to files
        if (!/\.(jpg|png|psd|ai)$/i.test(newFile.name)) {
          this.fileFormatError = true;
          return prevent();
        }

        if (this.currentLogosCount > 5) {
          return prevent();
        }
      }
    },

    getExistingFileName(file) {
      const nameArr = file.split('/');
      return nameArr[nameArr.length - 1];
    },

    addLogoClick() {
      const label = document.querySelector('.upl input');
      if (this.currentLogosCount > 4) return;
      label.click();
      this.fileFormatError = false;
    },
    closeRegModal() {
      if (this.formWatcher) {
        if (this.$metrika) {
          this.$metrika.reachGoal('offline-reg-declined');
        }
      }
      this.$emit('close');
    },
  },
};

</script>

<style scoped>

input[type=range] {
  -webkit-appearance: none;
  margin: 18px 0;
  width: 100%;
}

input[type=range]:focus {
  outline: none;
}

input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 2px;
  cursor: pointer;
  animate: 0.2s;
  background: #550045;
}

input[type=range]::-webkit-slider-thumb {
  box-shadow: 1px 1px 1px #bd006c, 0px 0px 1px #bd006c;
  border: 1px solid #bd006c;
  height: 20px;
  width: 20px;
  border-radius: 10px;
  background: #bd006c;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -9px;
  margin-bottom: -9px;
}

input[type=range]:focus::-webkit-slider-runnable-track {
  background: #550045;
  height: 2px;
}

input[type=range]::-moz-range-track {
  width: 100%;
  height: 1.4px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
  background: #550045;
  border-radius: 1.3px;
  border: 0.2px solid #550045;
}

input[type=range]::-moz-range-thumb {
  box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
  border: 1px solid #550045;
  height: 36px;
  width: 16px;
  border-radius: 3px;
  background: #550045;
  cursor: pointer;
}

input[type=range]::-ms-track {
  width: 100%;
  height: 1.4px;
  cursor: pointer;
  animate: 0.2s;
  background: transparent;
  border-color: transparent;
  border-width: 16px 0;
  color: transparent;
}

input[type=range]::-ms-fill-lower {
  background: #550045;
  border: 0.2px solid #550045;
  border-radius: 2.6px;
  box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
}

input[type=range]::-ms-fill-upper {
  background: #550045;
  border: 0.2px solid #550045;
  border-radius: 2.6px;
  box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
}

input[type=range]::-ms-thumb {
  box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
  border: 1px solid #550045;
  height: 20px;
  width: 20px;
  border-radius: 3px;
  background: #550045;
  cursor: pointer;
}

input[type=range]:focus::-ms-fill-lower {
  background: #550045;
}

input[type=range]:focus::-ms-fill-upper {
  background: #550045;
}

.rezerv {
  width: 100%;
  border-radius: 28px;
  border: 1px solid rgba(151, 151, 151, 0);
  background-color: #bd006c;
  outline: none;
}

.checkbox {
  display: none;
}

.checkbox-custom {
  position: relative;
  width: 20px;
  height: 20px;
  border: 2px solid #ccc;
  border-radius: 3px;

}

.checkbox-custom,
.label {
  display: inline-block;
  vertical-align: middle;
  @apply text-xs
}

.checkbox:checked + .checkbox-custom::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 2px;
  outline: 2px solid #979797;

  background-image: url("../../../../assets/SVG/modal-tick.svg");
  background-size: 0.9rem;
  background-position: center;

  background-repeat: no-repeat;
  color: #bd006c;
  font-weight: bold;
}

input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #979797;
  opacity: 1;
}

input[readonly] {
  cursor: default;
  color: #979797 !important;
}

.circle {
  width: 45px;
  height: 45px;
  background-color: #bd006c;
  border-radius: 30px;
}

.rotated {
  transform: rotate(90deg);
}

table tr td {
  @apply text-sm py-1;
}

.upl >>> label {
  z-index: -1 !important;
  cursor: pointer;
}

.selBox >>> #showBox {
  @apply w-full;
}

.spinner {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
